import React from "react";
import clsx from "clsx";
import styles from "./round-robin-match.module.scss";
import { PositionedBracketRoundRobin, Seed } from "core/models/Bracket";
import ArrowTail from "shared/icons/ArrowTail";
import FriendIcon from "shared/icons/Friend";

interface BracketBoxProps {
  positionedBracket: PositionedBracketRoundRobin;
  width: number;
  height: number;
  onFocus: (id: string) => void;
  onClick?: (seed: Seed) => void;
}

export const RoundRobinMatch: React.FC<BracketBoxProps> = ({
  positionedBracket,
  width,
  height,
  onFocus,
  onClick,
}) => {
  const teams = positionedBracket.seed.teams || [];
  const _regionClass =
    positionedBracket.region === "upper"
      ? styles.upper
      : positionedBracket.region === "lower"
      ? styles.lower
      : positionedBracket.region === "final"
      ? styles.final
      : styles.third;

  function handleClick() {
    onClick?.(positionedBracket.seed);
  }

  return (
    <div
      data-match
      data-bracket-id={positionedBracket.id}
      onDoubleClick={() => onFocus(positionedBracket.id)}
      className={styles.container}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleClick();
        }
      }}
      style={{
        width,
        height,
      }}
    >
      <div className={styles.header}>
        <p
          className={styles.title}
        >{`Match ${positionedBracket.seed.matchSequence}`}</p>
        <div className={styles.out}>
          <ArrowTail fontSize="8px" rotate={135} />
        </div>
      </div>
      <div className={styles.teams}>
        <div className={clsx(styles.team, styles.up)}>
          <div className={styles.details}>
            {teams?.[0]?.image ? (
              <img
                width={28}
                height={28}
                className={styles["team-logo"]}
                src={teams?.[0]?.image}
                alt="profile-img"
              />
            ) : (
              <FriendIcon fontSize="28px" color='hsla(0, 0%, 100%, .2)' />
            )}

            <div className={styles["team-name"]}>
              <p>{teams?.[0]?.name || "TBD"}</p>
            </div>
          </div>
          <p className={styles.score}>
            {positionedBracket.seed.isCompleted && teams?.[0]?.score}
          </p>
        </div>
        <div className={clsx(styles.team, styles.down)}>
          <div className={styles.details}>
            <FriendIcon fontSize="28px" color='hsla(0, 0%, 100%, .2)' />
            <div className={styles["team-name"]}>
              <p>{teams?.[1]?.name || "TBD"}</p>
            </div>
          </div>
          <p className={styles.score}>
            {positionedBracket.seed.isCompleted && teams?.[1]?.score}
          </p>
        </div>
      </div>
    </div>
  );
};
